export const enum EContentType {
  PDF = 'PDF',
  IMAGE = 'Image',
  TEXT = 'Text'
}
